// extracted by mini-css-extract-plugin
module.exports = {"custom":"SurveyModal_custom__zuQFN","surveyContainer":"SurveyModal_surveyContainer__8mxjU"};